import classNames from 'classnames'
import { FunctionComponent, useState } from 'react'
import { Table } from '../../shared'
import { BiologyReportResultProps } from './BiologyReportResult.model'
import { Result } from '../../../model/CdaContext'
import styles from './BiologyReportResult.module.scss'

export const BiologyReportResult: FunctionComponent<BiologyReportResultProps> = ({
  analysisResults,
}) => {
  const [refMapping, setRefMapping] = useState<Record<number, number>>()

  return (
    <div className={styles.biologyReportResultContainer}>
      <div className={styles.biologyReportResultContent}>
        <Table
          columns={[
            {
              title: 'Analyse',
              dataIndex: 'analysis',
            },
            {
              title: 'Résultat',
              dataIndex: 'value',
              render: ({ rowIndex, results }: { rowIndex: number; results: Result[] }) =>
                results.length > 1 ? (
                  <select
                    className={styles.biologyReportResultSelect}
                    onChange={(event) =>
                      setRefMapping((currentValue) => ({
                        ...currentValue,
                        [rowIndex]: parseInt(event.target.value, 10),
                      }))
                    }
                  >
                    {results.map((result, index) => (
                      <option className={styles.biologyReportResultSelectOption} value={index}>
                        {result.value}
                      </option>
                    ))}
                  </select>
                ) : (
                  results[0].value
                ),
            },
            {
              title: 'Référence',
              dataIndex: 'ref',
              render: (reference) => (
                <span className={styles.biologyReportResultReference}>{reference}</span>
              ),
            },
            { title: 'Interprétation', dataIndex: 'criticity' },
            {
              title: 'Commentaire',
              dataIndex: 'comment',
              render: (comment) => (
                <span className={styles.biologyReportResultComment}>{comment}</span>
              ),
            },
          ]}
          rows={analysisResults.map((row, index) => ({
            data: {
              ...row,
              value: { rowIndex: index, results: row.results },
              ref: row.results[refMapping ? refMapping[index] ?? 0 : 0].reference,
            },
            renderTd: (children) => (
              <td
                className={classNames(styles.biologyReportResult, {
                  [styles.critical]: row.critical,
                })}
              >
                {children}
              </td>
            ),
          }))}
        ></Table>
      </div>
    </div>
  )
}
